module.exports = __webpack_public_path__ + "static/media/027-teacher.ee6e8690.svg";